import { useContext } from "react";
import { ToastContainer } from "react-toastify";
import { ContextContracting } from "../../context";
import LoadingFull from "../../../../components/loading/loading-full";
// import PaymentTypeContracting from "../payment-type";
// import CreditCardForm from "../form-credit-card";
import FormUpdateDataStore from "../form-confirmation-data";
// import CardFormTeste from "./credit";
import CreditCardForm from "../form-credit-card";
import PaymentTypeContracting from "../payment-type";

const MainContracting = () => {
	const { stage, loading } = useContext(ContextContracting);
	return (
		<div className="container-forms">
			<ToastContainer mensagem="Carregando Arguarde..." />
			{loading && <LoadingFull />}
			{stage === 1 ? <FormUpdateDataStore /> : stage === 2 ? <PaymentTypeContracting /> : <CreditCardForm />}
		</div>
	);
};

export default MainContracting;
